import React from 'react'

function Error() {
  return <div className='container-fluid bg-dark'>
    <div className='row justify-content-center align-items-center span-color vh-100'>
        <h1 className='col-12 text-center'>Error Server not defined !!! <br/> 404</h1>
    </div>
  </div>
}

export default Error